export const landmarks = {
  type: "FeatureCollection",
  name: "landmarks",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 18.75,
        UN_VOL_POR: "01",
        UN_VOL_QE: 23.01,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.54,
        UN_VOL_QG: 20.29,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32605, 45.43697],
              [12.3259, 45.43688],
              [12.32582, 45.43683],
              [12.32581, 45.43682],
              [12.3258, 45.43683],
              [12.32575, 45.43688],
              [12.32573, 45.43689],
              [12.32581, 45.43694],
              [12.32597, 45.43703],
              [12.32605, 45.43697],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 14.55,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.58,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.66,
        UN_VOL_QG: 16.21,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32589, 45.4374],
              [12.32583, 45.43737],
              [12.32579, 45.4374],
              [12.32584, 45.43744],
              [12.32589, 45.4374],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 16.11,
        UN_VOL_POR: "01",
        UN_VOL_QE: 21.29,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.66,
        UN_VOL_QG: 17.77,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32621, 45.43744],
              [12.32577, 45.43718],
              [12.32576, 45.43719],
              [12.32567, 45.43726],
              [12.32567, 45.43727],
              [12.32583, 45.43737],
              [12.32589, 45.4374],
              [12.3261, 45.43753],
              [12.32611, 45.43752],
              [12.3262, 45.43745],
              [12.32621, 45.43744],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 4.64,
        UN_VOL_POR: "01",
        UN_VOL_QE: 6.32,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.62,
        UN_VOL_QG: 6.26,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32653, 45.43717],
              [12.32652, 45.43716],
              [12.32652, 45.43715],
              [12.32644, 45.4371],
              [12.32643, 45.43711],
              [12.32641, 45.4371],
              [12.32642, 45.43709],
              [12.32633, 45.43704],
              [12.32633, 45.43704],
              [12.32631, 45.43703],
              [12.32631, 45.43703],
              [12.32623, 45.43698],
              [12.32622, 45.43698],
              [12.3262, 45.43697],
              [12.3262, 45.43696],
              [12.32611, 45.43691],
              [12.32605, 45.43697],
              [12.32597, 45.43703],
              [12.32577, 45.43718],
              [12.32621, 45.43744],
              [12.32653, 45.43717],
            ],
            [
              [12.32586, 45.43718],
              [12.32612, 45.43697],
              [12.32645, 45.43717],
              [12.3262, 45.43738],
              [12.32586, 45.43718],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.52,
        UN_VOL_POR: "01",
        UN_VOL_QE: 31.76,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.78,
        UN_VOL_QG: 27.3,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32695, 45.43714],
              [12.3263, 45.43675],
              [12.32636, 45.4367],
              [12.32634, 45.43669],
              [12.32642, 45.43663],
              [12.32635, 45.43659],
              [12.32629, 45.43655],
              [12.32615, 45.43666],
              [12.32607, 45.43662],
              [12.32606, 45.43661],
              [12.32607, 45.43659],
              [12.32604, 45.43658],
              [12.32603, 45.43658],
              [12.32603, 45.43658],
              [12.32601, 45.4366],
              [12.32603, 45.4366],
              [12.32592, 45.43669],
              [12.32591, 45.43668],
              [12.32589, 45.43669],
              [12.3259, 45.4367],
              [12.32589, 45.4367],
              [12.32592, 45.43672],
              [12.32593, 45.43671],
              [12.32595, 45.43673],
              [12.32603, 45.43677],
              [12.3259, 45.43688],
              [12.32605, 45.43697],
              [12.32611, 45.43691],
              [12.32617, 45.43686],
              [12.32682, 45.43725],
              [12.32695, 45.43714],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.64,
        UN_VOL_POR: "01",
        UN_VOL_QE: 22.22,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.77,
        UN_VOL_QG: 19.41,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32677, 45.43729],
              [12.32677, 45.43729],
              [12.32677, 45.43729],
              [12.32682, 45.43725],
              [12.32617, 45.43686],
              [12.32611, 45.43691],
              [12.3262, 45.43696],
              [12.3262, 45.43697],
              [12.32622, 45.43698],
              [12.32623, 45.43698],
              [12.32631, 45.43703],
              [12.32631, 45.43703],
              [12.32633, 45.43704],
              [12.32633, 45.43704],
              [12.32642, 45.43709],
              [12.32641, 45.4371],
              [12.32643, 45.43711],
              [12.32644, 45.4371],
              [12.32652, 45.43715],
              [12.32652, 45.43716],
              [12.32653, 45.43717],
              [12.32654, 45.43717],
              [12.32654, 45.43717],
              [12.32656, 45.43718],
              [12.32666, 45.43724],
              [12.32674, 45.43729],
              [12.32673, 45.43729],
              [12.32675, 45.4373],
              [12.32676, 45.4373],
              [12.32677, 45.43729],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.14,
        UN_VOL_POR: "01",
        UN_VOL_QE: 21.84,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.89,
        UN_VOL_QG: 19.03,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32661, 45.43685],
              [12.32643, 45.43675],
              [12.32636, 45.4367],
              [12.3263, 45.43675],
              [12.32695, 45.43714],
              [12.32699, 45.4371],
              [12.327, 45.4371],
              [12.32702, 45.43709],
              [12.32661, 45.43685],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 13.16,
        UN_VOL_POR: "01",
        UN_VOL_QE: 18.24,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 14.67,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32666, 45.43724],
              [12.32656, 45.43718],
              [12.32654, 45.4372],
              [12.32663, 45.43726],
              [12.32666, 45.43724],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 9.62,
        UN_VOL_POR: "01",
        UN_VOL_QE: 11.97,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.32,
        UN_VOL_QG: 10.94,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3258, 45.43683],
              [12.32574, 45.43679],
              [12.3257, 45.4368],
              [12.32568, 45.43682],
              [12.32568, 45.43684],
              [12.32575, 45.43688],
              [12.3258, 45.43683],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.05,
        UN_VOL_POR: "01",
        UN_VOL_QE: 15.16,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.6,
        UN_VOL_QG: 13.65,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3261, 45.43753],
              [12.32589, 45.4374],
              [12.32584, 45.43744],
              [12.32599, 45.43753],
              [12.32588, 45.4376],
              [12.32593, 45.43764],
              [12.3261, 45.43753],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 14.63,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.55,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.58,
        UN_VOL_QG: 16.21,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32593, 45.43764],
              [12.32588, 45.4376],
              [12.32583, 45.43763],
              [12.32588, 45.43767],
              [12.32593, 45.43764],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.31,
        UN_VOL_POR: "01",
        UN_VOL_QE: 21.65,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.37,
        UN_VOL_QG: 16.68,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32651, 45.43756],
              [12.32647, 45.43751],
              [12.32646, 45.43751],
              [12.32639, 45.43753],
              [12.32637, 45.43754],
              [12.32632, 45.43752],
              [12.3264, 45.43745],
              [12.32651, 45.43736],
              [12.32663, 45.43726],
              [12.32654, 45.4372],
              [12.32656, 45.43718],
              [12.32654, 45.43717],
              [12.32654, 45.43717],
              [12.32653, 45.43717],
              [12.32621, 45.43744],
              [12.3262, 45.43745],
              [12.32611, 45.43752],
              [12.3261, 45.43753],
              [12.32593, 45.43764],
              [12.32588, 45.43767],
              [12.32566, 45.43781],
              [12.32568, 45.43783],
              [12.32572, 45.43785],
              [12.32573, 45.43786],
              [12.32587, 45.43775],
              [12.32651, 45.43756],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.1,
        UN_VOL_POR: "01",
        UN_VOL_QE: 14.83,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.63,
        UN_VOL_QG: 13.73,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32549, 45.43762],
              [12.32539, 45.43755],
              [12.32553, 45.43745],
              [12.32548, 45.43742],
              [12.32529, 45.43756],
              [12.32534, 45.43759],
              [12.32536, 45.43761],
              [12.32537, 45.43762],
              [12.32543, 45.43766],
              [12.32549, 45.43762],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 14.62,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.4,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.63,
        UN_VOL_QG: 16.25,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32554, 45.43765],
              [12.32549, 45.43762],
              [12.32543, 45.43766],
              [12.32547, 45.43768],
              [12.32549, 45.43769],
              [12.32554, 45.43765],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 11.82,
        UN_VOL_POR: "01",
        UN_VOL_QE: 14.95,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.64,
        UN_VOL_QG: 13.46,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32588, 45.43767],
              [12.32583, 45.43763],
              [12.32567, 45.43774],
              [12.32554, 45.43765],
              [12.32549, 45.43769],
              [12.32566, 45.43781],
              [12.32588, 45.43767],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 60.13,
        UN_VOL_POR: "01",
        UN_VOL_QE: 63.51,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.7,
        UN_VOL_QG: 61.83,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3264, 45.43665],
              [12.32637, 45.43667],
              [12.32637, 45.4367],
              [12.32641, 45.43673],
              [12.32646, 45.43673],
              [12.32648, 45.4367],
              [12.32648, 45.43668],
              [12.32644, 45.43665],
              [12.3264, 45.43665],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 13.43,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.34,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.83,
        UN_VOL_QG: 15.26,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32651, 45.43669],
              [12.32643, 45.43675],
              [12.32661, 45.43685],
              [12.32668, 45.43679],
              [12.32651, 45.43669],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 10.63,
        UN_VOL_POR: "01",
        UN_VOL_QE: 12.58,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.42,
        UN_VOL_QG: 12.05,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32581, 45.43694],
              [12.32573, 45.43689],
              [12.32572, 45.4369],
              [12.3257, 45.43692],
              [12.32578, 45.43697],
              [12.32581, 45.43694],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 16.13,
        UN_VOL_POR: "01",
        UN_VOL_QE: 21.43,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.75,
        UN_VOL_QG: 17.88,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32548, 45.43742],
              [12.32553, 45.43738],
              [12.32567, 45.43727],
              [12.32567, 45.43726],
              [12.32576, 45.43719],
              [12.32577, 45.43718],
              [12.32597, 45.43703],
              [12.32581, 45.43694],
              [12.32578, 45.43697],
              [12.32557, 45.43714],
              [12.32553, 45.43717],
              [12.32562, 45.43723],
              [12.32528, 45.43749],
              [12.32527, 45.43749],
              [12.32523, 45.43751],
              [12.32524, 45.43752],
              [12.32529, 45.43756],
              [12.32548, 45.43742],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 14.39,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.61,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.66,
        UN_VOL_QG: 16.05,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32558, 45.43741],
              [12.32553, 45.43738],
              [12.32548, 45.43742],
              [12.32553, 45.43745],
              [12.32558, 45.43741],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.22,
        UN_VOL_POR: "01",
        UN_VOL_QE: 15.19,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.66,
        UN_VOL_QG: 13.88,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32579, 45.4374],
              [12.32583, 45.43737],
              [12.32567, 45.43727],
              [12.32553, 45.43738],
              [12.32558, 45.43741],
              [12.32568, 45.43734],
              [12.32579, 45.4374],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 14.46,
        UN_VOL_POR: "01",
        UN_VOL_QE: 18.24,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.37,
        UN_VOL_QG: 15.83,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32624, 45.43652],
              [12.32629, 45.43655],
              [12.32635, 45.43659],
              [12.32641, 45.43654],
              [12.32631, 45.43648],
              [12.32627, 45.43648],
              [12.32624, 45.4365],
              [12.32624, 45.43652],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.77,
        UN_VOL_POR: "01",
        UN_VOL_QE: 30.48,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.53,
        UN_VOL_QG: 27.3,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32603, 45.43658],
              [12.32599, 45.43657],
              [12.32594, 45.43658],
              [12.3259, 45.4366],
              [12.32588, 45.43663],
              [12.32588, 45.43667],
              [12.32589, 45.43669],
              [12.32591, 45.43668],
              [12.32592, 45.43669],
              [12.32603, 45.4366],
              [12.32601, 45.4366],
              [12.32603, 45.43658],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.01,
        UN_VOL_POR: "01",
        UN_VOL_QE: 20.13,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.46,
        UN_VOL_QG: 16.47,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32595, 45.43673],
              [12.32592, 45.43673],
              [12.32591, 45.43676],
              [12.32588, 45.43677],
              [12.32587, 45.43679],
              [12.32584, 45.4368],
              [12.32582, 45.43683],
              [12.3259, 45.43688],
              [12.32603, 45.43677],
              [12.32595, 45.43673],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 14.15,
        UN_VOL_POR: "01",
        UN_VOL_QE: 19.59,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.85,
        UN_VOL_QG: 16.0,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32629, 45.43655],
              [12.32624, 45.43652],
              [12.3262, 45.43651],
              [12.32617, 45.43652],
              [12.32616, 45.43655],
              [12.32613, 45.43656],
              [12.32611, 45.43658],
              [12.32608, 45.43659],
              [12.32607, 45.43662],
              [12.32615, 45.43666],
              [12.32629, 45.43655],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 54.9,
        UN_VOL_POR: "01",
        UN_VOL_QE: 56.57,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.67,
        UN_VOL_QG: 56.57,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Basilica dei Frari",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32651, 45.43669],
              [12.32642, 45.43663],
              [12.32634, 45.43669],
              [12.32636, 45.4367],
              [12.32643, 45.43675],
              [12.32651, 45.43669],
            ],
            [
              [12.3264, 45.43665],
              [12.32644, 45.43665],
              [12.32648, 45.43668],
              [12.32648, 45.4367],
              [12.32646, 45.43673],
              [12.32641, 45.43673],
              [12.32637, 45.4367],
              [12.32637, 45.43667],
              [12.3264, 45.43665],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 20.08,
        UN_VOL_POR: "01",
        UN_VOL_QE: 25.25,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.04,
        UN_VOL_QG: 21.12,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Fondaco dei Tedeschi",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33696, 45.43846],
              [12.33706, 45.43845],
              [12.33704, 45.43841],
              [12.33689, 45.43802],
              [12.33686, 45.43802],
              [12.33638, 45.43811],
              [12.33629, 45.43812],
              [12.33645, 45.43854],
              [12.33696, 45.43846],
            ],
            [
              [12.3365, 45.43821],
              [12.33674, 45.43816],
              [12.33673, 45.43814],
              [12.33677, 45.43813],
              [12.33686, 45.43837],
              [12.33682, 45.43838],
              [12.33681, 45.43835],
              [12.33657, 45.43839],
              [12.3365, 45.43821],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 5.99,
        UN_VOL_POR: "01",
        UN_VOL_QE: 7.84,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.79,
        UN_VOL_QG: 7.78,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32137, 45.44163],
              [12.32121, 45.44172],
              [12.32122, 45.44173],
              [12.32122, 45.44173],
              [12.32138, 45.44164],
              [12.32137, 45.44163],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 13.41,
        UN_VOL_POR: "01",
        UN_VOL_QE: 18.94,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.16,
        UN_VOL_QG: 15.57,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32091, 45.44193],
              [12.3209, 45.44192],
              [12.32084, 45.44187],
              [12.32064, 45.44198],
              [12.32068, 45.44201],
              [12.32069, 45.44201],
              [12.32076, 45.44206],
              [12.32094, 45.44196],
              [12.32091, 45.44193],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 9.87,
        UN_VOL_POR: "01",
        UN_VOL_QE: 14.33,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.52,
        UN_VOL_QG: 12.39,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32119, 45.4413],
              [12.32134, 45.44121],
              [12.32092, 45.44084],
              [12.32071, 45.44096],
              [12.3207, 45.44096],
              [12.32113, 45.44133],
              [12.32119, 45.4413],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 1.54,
        UN_VOL_POR: "04",
        UN_VOL_QE: 8.91,
        UN_VOL_EX: "0",
        UN_VOL_QB: 6.57,
        UN_VOL_QG: 8.11,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32097, 45.44074],
              [12.32092, 45.44077],
              [12.32087, 45.4408],
              [12.32092, 45.44084],
              [12.32134, 45.44121],
              [12.32138, 45.44125],
              [12.32149, 45.44119],
              [12.32098, 45.44074],
              [12.32097, 45.44074],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 6.88,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.01,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.42,
        UN_VOL_QG: 9.3,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32085, 45.44078],
              [12.32087, 45.4408],
              [12.32092, 45.44077],
              [12.32076, 45.44062],
              [12.32052, 45.44075],
              [12.32045, 45.44079],
              [12.32045, 45.44079],
              [12.32038, 45.44083],
              [12.32044, 45.44089],
              [12.32077, 45.44071],
              [12.32085, 45.44078],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 7.27,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.19,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.68,
        UN_VOL_QG: 9.95,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32092, 45.44084],
              [12.32087, 45.4408],
              [12.32085, 45.44078],
              [12.32064, 45.44089],
              [12.32071, 45.44096],
              [12.32092, 45.44084],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 7.92,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.95,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.1,
        UN_VOL_QG: 10.02,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32138, 45.44151],
              [12.32141, 45.44149],
              [12.32136, 45.44145],
              [12.32121, 45.44154],
              [12.32125, 45.44158],
              [12.32138, 45.44151],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 7.31,
        UN_VOL_POR: "01",
        UN_VOL_QE: 9.54,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.22,
        UN_VOL_QG: 9.53,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32136, 45.44145],
              [12.32119, 45.4413],
              [12.32113, 45.44133],
              [12.32103, 45.44139],
              [12.32121, 45.44154],
              [12.32136, 45.44145],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 7.16,
        UN_VOL_POR: "01",
        UN_VOL_QE: 11.31,
        UN_VOL_EX: "0",
        UN_VOL_QB: 3.88,
        UN_VOL_QG: 11.04,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32128, 45.44164],
              [12.32123, 45.44159],
              [12.32125, 45.44158],
              [12.32121, 45.44154],
              [12.32103, 45.44139],
              [12.32102, 45.4414],
              [12.32059, 45.44103],
              [12.32059, 45.44103],
              [12.32044, 45.4409],
              [12.32044, 45.44089],
              [12.32038, 45.44083],
              [12.32034, 45.4408],
              [12.32033, 45.4408],
              [12.32032, 45.4408],
              [12.32022, 45.44086],
              [12.32021, 45.44086],
              [12.32022, 45.44087],
              [12.32025, 45.44089],
              [12.32112, 45.44166],
              [12.32115, 45.44169],
              [12.32117, 45.4417],
              [12.32128, 45.44164],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 5.86,
        UN_VOL_POR: "01",
        UN_VOL_QE: 8.88,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.81,
        UN_VOL_QG: 8.67,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32103, 45.44139],
              [12.32113, 45.44133],
              [12.3207, 45.44096],
              [12.32059, 45.44103],
              [12.32102, 45.4414],
              [12.32103, 45.44139],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 7.02,
        UN_VOL_POR: "01",
        UN_VOL_QE: 11.52,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.1,
        UN_VOL_QG: 9.12,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32094, 45.44192],
              [12.32101, 45.44188],
              [12.32101, 45.44189],
              [12.32107, 45.44185],
              [12.32106, 45.44185],
              [12.32113, 45.44181],
              [12.32112, 45.4418],
              [12.32118, 45.44177],
              [12.32119, 45.44176],
              [12.32118, 45.44175],
              [12.32122, 45.44173],
              [12.32121, 45.44172],
              [12.32137, 45.44163],
              [12.32137, 45.44163],
              [12.32143, 45.44159],
              [12.32143, 45.44159],
              [12.32143, 45.44159],
              [12.3214, 45.44157],
              [12.32128, 45.44164],
              [12.32117, 45.4417],
              [12.32115, 45.44169],
              [12.32084, 45.44187],
              [12.3209, 45.44192],
              [12.32093, 45.44191],
              [12.32094, 45.44192],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 6.88,
        UN_VOL_POR: "01",
        UN_VOL_QE: 9.07,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.12,
        UN_VOL_QG: 9.0,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32094, 45.44192],
              [12.32093, 45.44191],
              [12.3209, 45.44192],
              [12.32091, 45.44193],
              [12.32094, 45.44192],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 0.21,
        UN_VOL_POR: "04",
        UN_VOL_QE: 7.79,
        UN_VOL_EX: "0",
        UN_VOL_QB: 7.13,
        UN_VOL_QG: 7.34,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.31825, 45.44197],
              [12.31822, 45.44199],
              [12.31815, 45.44203],
              [12.31795, 45.44215],
              [12.31782, 45.44223],
              [12.31781, 45.44224],
              [12.3178, 45.44225],
              [12.3178, 45.44226],
              [12.3178, 45.44227],
              [12.31781, 45.44228],
              [12.31782, 45.44228],
              [12.31783, 45.44229],
              [12.31784, 45.44229],
              [12.31785, 45.44229],
              [12.31786, 45.44229],
              [12.31788, 45.44228],
              [12.3202, 45.44097],
              [12.32024, 45.44095],
              [12.32029, 45.44099],
              [12.32025, 45.44101],
              [12.31793, 45.44232],
              [12.31791, 45.44234],
              [12.31791, 45.44235],
              [12.31791, 45.44235],
              [12.31791, 45.44236],
              [12.31792, 45.44237],
              [12.31793, 45.44238],
              [12.31794, 45.44238],
              [12.31795, 45.44239],
              [12.31796, 45.44239],
              [12.31797, 45.44239],
              [12.31798, 45.44239],
              [12.31799, 45.44238],
              [12.32031, 45.44107],
              [12.32035, 45.44105],
              [12.3204, 45.44109],
              [12.32036, 45.44111],
              [12.31771, 45.44261],
              [12.3177, 45.44261],
              [12.3177, 45.44262],
              [12.31769, 45.44262],
              [12.31769, 45.44263],
              [12.31769, 45.44264],
              [12.3177, 45.44266],
              [12.31771, 45.44266],
              [12.31773, 45.44267],
              [12.31774, 45.44267],
              [12.31776, 45.44267],
              [12.31777, 45.44267],
              [12.31778, 45.44266],
              [12.32043, 45.44117],
              [12.32046, 45.44115],
              [12.32054, 45.44121],
              [12.3205, 45.44123],
              [12.31775, 45.44279],
              [12.31753, 45.44292],
              [12.31752, 45.44293],
              [12.31752, 45.44294],
              [12.31751, 45.44295],
              [12.31752, 45.44296],
              [12.31752, 45.44296],
              [12.31753, 45.44297],
              [12.31754, 45.44298],
              [12.31756, 45.44298],
              [12.31757, 45.44298],
              [12.31759, 45.44297],
              [12.32057, 45.44129],
              [12.32061, 45.44127],
              [12.32068, 45.44134],
              [12.32064, 45.44136],
              [12.31766, 45.44304],
              [12.31765, 45.44305],
              [12.31765, 45.44306],
              [12.31765, 45.44307],
              [12.31765, 45.44308],
              [12.31766, 45.44309],
              [12.31765, 45.44309],
              [12.31766, 45.44309],
              [12.31766, 45.44309],
              [12.31767, 45.4431],
              [12.31768, 45.4431],
              [12.31769, 45.4431],
              [12.3177, 45.4431],
              [12.31771, 45.4431],
              [12.31772, 45.4431],
              [12.31773, 45.4431],
              [12.32071, 45.44141],
              [12.32075, 45.44139],
              [12.32082, 45.44146],
              [12.32078, 45.44148],
              [12.31782, 45.44315],
              [12.3178, 45.44317],
              [12.31779, 45.44318],
              [12.31779, 45.44318],
              [12.31779, 45.44319],
              [12.31779, 45.4432],
              [12.31779, 45.44321],
              [12.3178, 45.44321],
              [12.31781, 45.44322],
              [12.31782, 45.44323],
              [12.31783, 45.44323],
              [12.31785, 45.44323],
              [12.31786, 45.44323],
              [12.31787, 45.44322],
              [12.31789, 45.44321],
              [12.32085, 45.44154],
              [12.32089, 45.44152],
              [12.32094, 45.44156],
              [12.3209, 45.44158],
              [12.31792, 45.44326],
              [12.31791, 45.44327],
              [12.31791, 45.44327],
              [12.3179, 45.44328],
              [12.3179, 45.44329],
              [12.3179, 45.44329],
              [12.31791, 45.4433],
              [12.31791, 45.44331],
              [12.31792, 45.44331],
              [12.31792, 45.44332],
              [12.31793, 45.44332],
              [12.31794, 45.44332],
              [12.31795, 45.44333],
              [12.31796, 45.44333],
              [12.31797, 45.44332],
              [12.31798, 45.44332],
              [12.31799, 45.44332],
              [12.32096, 45.44164],
              [12.321, 45.44162],
              [12.32105, 45.44166],
              [12.32101, 45.44168],
              [12.31838, 45.44317],
              [12.31846, 45.44324],
              [12.31917, 45.44284],
              [12.31934, 45.44274],
              [12.31941, 45.4427],
              [12.31943, 45.4427],
              [12.31941, 45.44268],
              [12.31963, 45.44255],
              [12.31982, 45.44245],
              [12.32064, 45.44198],
              [12.32084, 45.44187],
              [12.32115, 45.44169],
              [12.32112, 45.44166],
              [12.32025, 45.44089],
              [12.32022, 45.44087],
              [12.32005, 45.44097],
              [12.32005, 45.44097],
              [12.31957, 45.44124],
              [12.31924, 45.44142],
              [12.31844, 45.44187],
              [12.31844, 45.44188],
              [12.31825, 45.44198],
              [12.31825, 45.44197],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 4.18,
        UN_VOL_POR: "01",
        UN_VOL_QE: 8.2,
        UN_VOL_EX: "0",
        UN_VOL_QB: 3.88,
        UN_VOL_QG: 8.06,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32032, 45.4408],
              [12.32019, 45.44069],
              [12.32031, 45.44063],
              [12.32026, 45.44059],
              [12.32025, 45.44058],
              [12.32014, 45.44064],
              [12.32003, 45.4407],
              [12.32011, 45.44077],
              [12.32013, 45.44079],
              [12.32014, 45.44079],
              [12.32022, 45.44086],
              [12.32032, 45.4408],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 5.55,
        UN_VOL_POR: "01",
        UN_VOL_QE: 9.04,
        UN_VOL_EX: "0",
        UN_VOL_QB: 3.39,
        UN_VOL_QG: 8.94,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32022, 45.44087],
              [12.32021, 45.44086],
              [12.32022, 45.44086],
              [12.32014, 45.44079],
              [12.32013, 45.44079],
              [12.31996, 45.44089],
              [12.32005, 45.44097],
              [12.32005, 45.44097],
              [12.32022, 45.44087],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 9.66,
        UN_VOL_POR: "01",
        UN_VOL_QE: 12.93,
        UN_VOL_EX: "0",
        UN_VOL_QB: 3.24,
        UN_VOL_QG: 12.9,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32005, 45.44097],
              [12.31996, 45.44089],
              [12.31965, 45.44106],
              [12.31948, 45.44116],
              [12.31957, 45.44124],
              [12.32005, 45.44097],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 10.02,
        UN_VOL_POR: "01",
        UN_VOL_QE: 13.73,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.91,
        UN_VOL_QG: 12.93,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.31957, 45.44124],
              [12.31948, 45.44116],
              [12.31916, 45.44134],
              [12.3192, 45.44137],
              [12.31919, 45.44138],
              [12.31924, 45.44142],
              [12.31957, 45.44124],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 10.5,
        UN_VOL_POR: "01",
        UN_VOL_QE: 14.79,
        UN_VOL_EX: "0",
        UN_VOL_QB: 4.0,
        UN_VOL_QG: 14.5,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32059, 45.44103],
              [12.3207, 45.44096],
              [12.32071, 45.44096],
              [12.32064, 45.44089],
              [12.32085, 45.44078],
              [12.32077, 45.44071],
              [12.32044, 45.44089],
              [12.32044, 45.4409],
              [12.32059, 45.44103],
              [12.32059, 45.44103],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.82,
        UN_VOL_POR: "01",
        UN_VOL_QE: 14.94,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.09,
        UN_VOL_QG: 14.91,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3214, 45.44157],
              [12.32143, 45.44155],
              [12.32138, 45.44151],
              [12.32125, 45.44158],
              [12.32123, 45.44159],
              [12.32128, 45.44164],
              [12.3214, 45.44157],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.58,
        UN_VOL_POR: "01",
        UN_VOL_QE: 15.09,
        UN_VOL_EX: "0",
        UN_VOL_QB: 2.06,
        UN_VOL_QG: 14.64,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32147, 45.44153],
              [12.3215, 45.44152],
              [12.32159, 45.44146],
              [12.32161, 45.44145],
              [12.32161, 45.44145],
              [12.32161, 45.44145],
              [12.32152, 45.44137],
              [12.32148, 45.44133],
              [12.32146, 45.44131],
              [12.3214, 45.44126],
              [12.32138, 45.44125],
              [12.32134, 45.44121],
              [12.32119, 45.4413],
              [12.32136, 45.44145],
              [12.32141, 45.44149],
              [12.32141, 45.44149],
              [12.32146, 45.44153],
              [12.32147, 45.44153],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 6.15,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.18,
        UN_VOL_EX: "0",
        UN_VOL_QB: 3.97,
        UN_VOL_QG: 10.12,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32034, 45.4408],
              [12.32041, 45.44076],
              [12.32049, 45.44072],
              [12.32037, 45.44061],
              [12.32036, 45.4406],
              [12.32031, 45.44063],
              [12.32019, 45.44069],
              [12.32032, 45.4408],
              [12.32033, 45.4408],
              [12.32034, 45.4408],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 5.07,
        UN_VOL_POR: "01",
        UN_VOL_QE: 9.47,
        UN_VOL_EX: "0",
        UN_VOL_QB: 4.37,
        UN_VOL_QG: 9.44,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32045, 45.44079],
              [12.32041, 45.44076],
              [12.32034, 45.4408],
              [12.32038, 45.44083],
              [12.32045, 45.44079],
              [12.32045, 45.44079],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 3.83,
        UN_VOL_POR: "01",
        UN_VOL_QE: 7.79,
        UN_VOL_EX: "0",
        UN_VOL_QB: 3.51,
        UN_VOL_QG: 7.34,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.31825, 45.44197],
              [12.31818, 45.44192],
              [12.31816, 45.4419],
              [12.31835, 45.4418],
              [12.31897, 45.44145],
              [12.31901, 45.44142],
              [12.31911, 45.44137],
              [12.31916, 45.44134],
              [12.31948, 45.44116],
              [12.31965, 45.44106],
              [12.31996, 45.44089],
              [12.32013, 45.44079],
              [12.32011, 45.44077],
              [12.32008, 45.44078],
              [12.32, 45.44083],
              [12.31962, 45.44104],
              [12.31924, 45.44126],
              [12.31903, 45.44137],
              [12.31894, 45.44142],
              [12.31838, 45.44174],
              [12.31814, 45.44188],
              [12.31813, 45.44189],
              [12.31813, 45.44189],
              [12.31813, 45.4419],
              [12.31813, 45.44191],
              [12.31813, 45.44192],
              [12.31815, 45.44193],
              [12.31822, 45.44199],
              [12.31825, 45.44197],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 2.71,
        UN_VOL_POR: "01",
        UN_VOL_QE: 7.38,
        UN_VOL_EX: "0",
        UN_VOL_QB: 4.64,
        UN_VOL_QG: 7.35,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Lucia Railway Station",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.32052, 45.44075],
              [12.32049, 45.44072],
              [12.32041, 45.44076],
              [12.32045, 45.44079],
              [12.32052, 45.44075],
            ],
            [
              [12.32046, 45.44075],
              [12.32047, 45.44074],
              [12.32049, 45.44076],
              [12.32048, 45.44077],
              [12.32046, 45.44075],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 8.4,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.29,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.49,
        UN_VOL_QG: 8.89,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Rialto Bridge",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3358, 45.43823],
              [12.33594, 45.43815],
              [12.3359, 45.43811],
              [12.33576, 45.4382],
              [12.33571, 45.43823],
              [12.33575, 45.43827],
              [12.3358, 45.43823],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.35,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.13,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.23,
        UN_VOL_QG: 15.58,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Rialto Bridge",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33602, 45.43811],
              [12.33597, 45.43807],
              [12.33597, 45.43807],
              [12.3359, 45.43811],
              [12.3359, 45.43811],
              [12.33594, 45.43815],
              [12.33595, 45.43816],
              [12.33602, 45.43811],
              [12.33602, 45.43811],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 7.83,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.22,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.18,
        UN_VOL_QG: 9.01,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Rialto Bridge",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33615, 45.43803],
              [12.33622, 45.43799],
              [12.33617, 45.43795],
              [12.33611, 45.43799],
              [12.33597, 45.43807],
              [12.33602, 45.43811],
              [12.33615, 45.43803],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 7.94,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.59,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.05,
        UN_VOL_QG: 8.99,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2019/01/03",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "GEOSBROGIO",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Rialto Bridge",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33612, 45.43791],
              [12.33608, 45.43787],
              [12.33601, 45.43791],
              [12.33588, 45.43799],
              [12.33592, 45.43803],
              [12.33606, 45.43795],
              [12.33612, 45.43791],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 8.42,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.18,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.54,
        UN_VOL_QG: 8.96,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2019/01/03",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "GEOSBROGIO",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Rialto Bridge",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33585, 45.43807],
              [12.33581, 45.43803],
              [12.33567, 45.43811],
              [12.33561, 45.43815],
              [12.33565, 45.43819],
              [12.33571, 45.43815],
              [12.33585, 45.43807],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.48,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.18,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.23,
        UN_VOL_QG: 15.71,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2019/01/03",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "GEOSBROGIO",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Rialto Bridge",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33588, 45.43799],
              [12.33588, 45.43799],
              [12.33581, 45.43803],
              [12.33581, 45.43803],
              [12.33585, 45.43807],
              [12.33586, 45.43808],
              [12.33593, 45.43803],
              [12.33592, 45.43803],
              [12.33588, 45.43799],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.0,
        UN_VOL_POR: "01",
        UN_VOL_QE: 22.69,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 18.51,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.335, 45.43074],
              [12.335, 45.43067],
              [12.335, 45.43066],
              [12.33497, 45.43066],
              [12.33495, 45.43065],
              [12.33495, 45.43075],
              [12.335, 45.43075],
              [12.335, 45.43074],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 16.99,
        UN_VOL_POR: "01",
        UN_VOL_QE: 20.53,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 18.5,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33491, 45.43085],
              [12.33496, 45.43082],
              [12.33492, 45.43079],
              [12.33482, 45.43085],
              [12.33486, 45.43088],
              [12.33491, 45.43085],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.03,
        UN_VOL_POR: "01",
        UN_VOL_QE: 24.24,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 18.54,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33447, 45.43064],
              [12.33442, 45.43064],
              [12.33441, 45.43073],
              [12.33446, 45.43074],
              [12.33447, 45.43064],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 36.58,
        UN_VOL_POR: "01",
        UN_VOL_QE: 62.14,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 38.09,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33486, 45.43067],
              [12.33486, 45.43066],
              [12.33485, 45.43065],
              [12.33485, 45.43064],
              [12.33484, 45.43063],
              [12.33482, 45.43062],
              [12.33481, 45.43061],
              [12.3348, 45.4306],
              [12.33478, 45.43059],
              [12.33477, 45.43059],
              [12.33475, 45.43058],
              [12.33473, 45.43058],
              [12.33471, 45.43058],
              [12.33469, 45.43058],
              [12.33468, 45.43058],
              [12.33466, 45.43058],
              [12.33464, 45.43059],
              [12.33462, 45.43059],
              [12.33461, 45.4306],
              [12.33459, 45.43061],
              [12.33458, 45.43062],
              [12.33457, 45.43063],
              [12.33457, 45.43063],
              [12.33456, 45.43064],
              [12.33455, 45.43065],
              [12.33454, 45.43066],
              [12.33454, 45.43068],
              [12.33454, 45.43069],
              [12.33454, 45.4307],
              [12.33454, 45.43072],
              [12.33455, 45.43073],
              [12.33455, 45.43074],
              [12.33456, 45.43075],
              [12.33457, 45.43076],
              [12.33458, 45.43077],
              [12.3346, 45.43078],
              [12.33461, 45.43079],
              [12.33463, 45.4308],
              [12.33465, 45.4308],
              [12.33466, 45.4308],
              [12.33468, 45.43081],
              [12.3347, 45.43081],
              [12.33472, 45.43081],
              [12.33473, 45.43081],
              [12.33475, 45.4308],
              [12.33477, 45.4308],
              [12.33479, 45.43079],
              [12.3348, 45.43078],
              [12.33481, 45.43078],
              [12.33483, 45.43077],
              [12.33484, 45.43076],
              [12.33485, 45.43075],
              [12.33486, 45.43073],
              [12.33486, 45.43072],
              [12.33486, 45.43071],
              [12.33487, 45.4307],
              [12.33487, 45.43068],
              [12.33486, 45.43067],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 30.88,
        UN_VOL_POR: "01",
        UN_VOL_QE: 33.72,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 32.39,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33477, 45.43082],
              [12.3348, 45.4308],
              [12.3348, 45.4308],
              [12.33485, 45.43077],
              [12.33485, 45.43077],
              [12.33488, 45.43075],
              [12.33489, 45.43073],
              [12.33488, 45.43073],
              [12.33488, 45.43068],
              [12.33489, 45.43068],
              [12.33489, 45.43065],
              [12.33486, 45.43063],
              [12.33486, 45.43063],
              [12.33481, 45.43059],
              [12.33481, 45.43059],
              [12.33479, 45.43057],
              [12.33475, 45.43057],
              [12.33475, 45.43058],
              [12.33468, 45.43057],
              [12.33468, 45.43057],
              [12.33464, 45.43057],
              [12.33461, 45.43058],
              [12.33462, 45.43059],
              [12.33457, 45.43062],
              [12.33456, 45.43062],
              [12.33453, 45.43064],
              [12.33453, 45.43067],
              [12.33454, 45.43067],
              [12.33454, 45.43072],
              [12.33453, 45.43072],
              [12.33453, 45.43074],
              [12.33455, 45.43076],
              [12.33456, 45.43076],
              [12.33461, 45.4308],
              [12.3346, 45.4308],
              [12.33463, 45.43082],
              [12.33466, 45.43082],
              [12.33466, 45.43081],
              [12.33474, 45.43081],
              [12.33474, 45.43082],
              [12.33477, 45.43082],
            ],
            [
              [12.33457, 45.43076],
              [12.33456, 45.43075],
              [12.33455, 45.43074],
              [12.33455, 45.43073],
              [12.33454, 45.43072],
              [12.33454, 45.4307],
              [12.33454, 45.43069],
              [12.33454, 45.43068],
              [12.33454, 45.43066],
              [12.33455, 45.43065],
              [12.33456, 45.43064],
              [12.33457, 45.43063],
              [12.33457, 45.43063],
              [12.33458, 45.43062],
              [12.33459, 45.43061],
              [12.33461, 45.4306],
              [12.33462, 45.43059],
              [12.33464, 45.43059],
              [12.33466, 45.43058],
              [12.33468, 45.43058],
              [12.33469, 45.43058],
              [12.33471, 45.43058],
              [12.33473, 45.43058],
              [12.33475, 45.43058],
              [12.33477, 45.43059],
              [12.33478, 45.43059],
              [12.3348, 45.4306],
              [12.33481, 45.43061],
              [12.33482, 45.43062],
              [12.33484, 45.43063],
              [12.33485, 45.43064],
              [12.33485, 45.43065],
              [12.33486, 45.43066],
              [12.33486, 45.43067],
              [12.33487, 45.43068],
              [12.33487, 45.4307],
              [12.33486, 45.43071],
              [12.33486, 45.43072],
              [12.33486, 45.43073],
              [12.33485, 45.43075],
              [12.33484, 45.43076],
              [12.33483, 45.43077],
              [12.33481, 45.43078],
              [12.3348, 45.43078],
              [12.33479, 45.43079],
              [12.33477, 45.4308],
              [12.33475, 45.4308],
              [12.33473, 45.43081],
              [12.33472, 45.43081],
              [12.3347, 45.43081],
              [12.33468, 45.43081],
              [12.33466, 45.4308],
              [12.33465, 45.4308],
              [12.33463, 45.4308],
              [12.33461, 45.43079],
              [12.3346, 45.43078],
              [12.33458, 45.43077],
              [12.33457, 45.43076],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 16.14,
        UN_VOL_POR: "01",
        UN_VOL_QE: 29.79,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 17.65,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33482, 45.43085],
              [12.33492, 45.43079],
              [12.33495, 45.43078],
              [12.33495, 45.43075],
              [12.33495, 45.43065],
              [12.33495, 45.43063],
              [12.33493, 45.43062],
              [12.33483, 45.43054],
              [12.33473, 45.43054],
              [12.3347, 45.43054],
              [12.3346, 45.43054],
              [12.33449, 45.4306],
              [12.33447, 45.43061],
              [12.33447, 45.43064],
              [12.33446, 45.43074],
              [12.33446, 45.43076],
              [12.33448, 45.43077],
              [12.33457, 45.43085],
              [12.33456, 45.4309],
              [12.33457, 45.4309],
              [12.33457, 45.4309],
              [12.33482, 45.43091],
              [12.33482, 45.43088],
              [12.33481, 45.43087],
              [12.33481, 45.43086],
              [12.33482, 45.43085],
            ],
            [
              [12.33477, 45.43082],
              [12.33474, 45.43082],
              [12.33474, 45.43081],
              [12.33466, 45.43081],
              [12.33466, 45.43082],
              [12.33463, 45.43082],
              [12.3346, 45.4308],
              [12.33461, 45.4308],
              [12.33456, 45.43076],
              [12.33455, 45.43076],
              [12.33453, 45.43074],
              [12.33453, 45.43072],
              [12.33454, 45.43072],
              [12.33454, 45.43067],
              [12.33453, 45.43067],
              [12.33453, 45.43064],
              [12.33456, 45.43062],
              [12.33457, 45.43062],
              [12.33462, 45.43059],
              [12.33461, 45.43058],
              [12.33464, 45.43057],
              [12.33468, 45.43057],
              [12.33468, 45.43057],
              [12.33475, 45.43058],
              [12.33475, 45.43057],
              [12.33479, 45.43057],
              [12.33481, 45.43059],
              [12.33481, 45.43059],
              [12.33486, 45.43063],
              [12.33486, 45.43063],
              [12.33489, 45.43065],
              [12.33489, 45.43068],
              [12.33488, 45.43068],
              [12.33488, 45.43073],
              [12.33489, 45.43073],
              [12.33488, 45.43075],
              [12.33485, 45.43077],
              [12.33485, 45.43077],
              [12.3348, 45.4308],
              [12.3348, 45.4308],
              [12.33477, 45.43082],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.07,
        UN_VOL_POR: "01",
        UN_VOL_QE: 23.53,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 18.58,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33457, 45.43085],
              [12.33448, 45.43077],
              [12.33444, 45.4308],
              [12.33449, 45.43084],
              [12.33454, 45.43087],
              [12.33457, 45.43085],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 40.18,
        UN_VOL_POR: "01",
        UN_VOL_QE: 48.22,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 41.69,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33465, 45.43041],
              [12.33465, 45.43037],
              [12.33465, 45.43036],
              [12.33463, 45.43036],
              [12.33459, 45.43036],
              [12.33459, 45.43037],
              [12.33459, 45.4304],
              [12.33458, 45.43041],
              [12.33464, 45.43041],
              [12.33465, 45.43041],
              [12.33465, 45.43041],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.77,
        UN_VOL_POR: "01",
        UN_VOL_QE: 27.27,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.5,
        UN_VOL_QG: 27.27,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3348, 45.43041],
              [12.3348, 45.43037],
              [12.33465, 45.43037],
              [12.33465, 45.43041],
              [12.33468, 45.43039],
              [12.3347, 45.43039],
              [12.33473, 45.43039],
              [12.33477, 45.4304],
              [12.3348, 45.43041],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 24.72,
        UN_VOL_POR: "01",
        UN_VOL_QE: 29.94,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 26.23,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3347, 45.43054],
              [12.33468, 45.43053],
              [12.33464, 45.43052],
              [12.33462, 45.43049],
              [12.33461, 45.43047],
              [12.33462, 45.43044],
              [12.33464, 45.43041],
              [12.33458, 45.43041],
              [12.33459, 45.4304],
              [12.33456, 45.43041],
              [12.33454, 45.43043],
              [12.33452, 45.43044],
              [12.33452, 45.43046],
              [12.33452, 45.43048],
              [12.33453, 45.43049],
              [12.33455, 45.43051],
              [12.33456, 45.43051],
              [12.33458, 45.43052],
              [12.3346, 45.43052],
              [12.3346, 45.43054],
              [12.3347, 45.43054],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 31.21,
        UN_VOL_POR: "01",
        UN_VOL_QE: 50.74,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 32.72,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33473, 45.43054],
              [12.33476, 45.43053],
              [12.33479, 45.43052],
              [12.33481, 45.43051],
              [12.33483, 45.43048],
              [12.33483, 45.43046],
              [12.33482, 45.43044],
              [12.33481, 45.43042],
              [12.3348, 45.43042],
              [12.3348, 45.43041],
              [12.33477, 45.4304],
              [12.33473, 45.43039],
              [12.3347, 45.43039],
              [12.33468, 45.43039],
              [12.33465, 45.43041],
              [12.33465, 45.43041],
              [12.33464, 45.43041],
              [12.33462, 45.43044],
              [12.33461, 45.43047],
              [12.33462, 45.43049],
              [12.33464, 45.43052],
              [12.33468, 45.43053],
              [12.3347, 45.43054],
              [12.33473, 45.43054],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.27,
        UN_VOL_POR: "01",
        UN_VOL_QE: 23.21,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 18.78,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3346, 45.43054],
              [12.3346, 45.43052],
              [12.33458, 45.43052],
              [12.33456, 45.43051],
              [12.33446, 45.43058],
              [12.33449, 45.4306],
              [12.3346, 45.43054],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 40.05,
        UN_VOL_POR: "01",
        UN_VOL_QE: 48.1,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.5,
        UN_VOL_QG: 41.55,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33487, 45.43041],
              [12.33487, 45.43037],
              [12.33482, 45.43037],
              [12.3348, 45.43037],
              [12.3348, 45.43037],
              [12.3348, 45.43041],
              [12.3348, 45.43042],
              [12.33481, 45.43042],
              [12.33487, 45.43042],
              [12.33487, 45.43041],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.34,
        UN_VOL_POR: "01",
        UN_VOL_QE: 27.76,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.5,
        UN_VOL_QG: 26.84,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33483, 45.43054],
              [12.33483, 45.43053],
              [12.33486, 45.43053],
              [12.33488, 45.43052],
              [12.3349, 45.43051],
              [12.33491, 45.4305],
              [12.33492, 45.43048],
              [12.33492, 45.43046],
              [12.33492, 45.43045],
              [12.33491, 45.43043],
              [12.33487, 45.43041],
              [12.33487, 45.43042],
              [12.33481, 45.43042],
              [12.33482, 45.43044],
              [12.33483, 45.43046],
              [12.33483, 45.43048],
              [12.33481, 45.43051],
              [12.33479, 45.43052],
              [12.33476, 45.43053],
              [12.33473, 45.43054],
              [12.33483, 45.43054],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 16.88,
        UN_VOL_POR: "01",
        UN_VOL_QE: 19.9,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 18.39,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33496, 45.43059],
              [12.3349, 45.43054],
              [12.33488, 45.43052],
              [12.33486, 45.43053],
              [12.33483, 45.43053],
              [12.33483, 45.43054],
              [12.33493, 45.43062],
              [12.33497, 45.43059],
              [12.33496, 45.43059],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 2.81,
        UN_VOL_POR: "01",
        UN_VOL_QE: 4.48,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.5,
        UN_VOL_QG: 4.31,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3349, 45.43054],
              [12.33496, 45.43059],
              [12.33501, 45.43056],
              [12.33495, 45.43051],
              [12.3349, 45.43054],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 3.27,
        UN_VOL_POR: "01",
        UN_VOL_QE: 5.3,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.51,
        UN_VOL_QG: 4.78,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "Santa Maria della Salute",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33497, 45.43066],
              [12.335, 45.43066],
              [12.33505, 45.43066],
              [12.33506, 45.43058],
              [12.33498, 45.43058],
              [12.33497, 45.43066],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 10.09,
        UN_VOL_POR: "01",
        UN_VOL_QE: 11.09,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.57,
        UN_VOL_QG: 10.66,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3405, 45.4349],
              [12.3403, 45.43486],
              [12.34029, 45.43487],
              [12.34046, 45.43491],
              [12.34046, 45.43491],
              [12.34047, 45.43491],
              [12.34046, 45.43495],
              [12.34048, 45.43495],
              [12.34049, 45.43495],
              [12.3405, 45.4349],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 18.61,
        UN_VOL_POR: "01",
        UN_VOL_QE: 20.54,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.86,
        UN_VOL_QG: 19.47,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34035, 45.435],
              [12.34029, 45.43498],
              [12.34024, 45.43509],
              [12.34023, 45.43511],
              [12.34022, 45.43514],
              [12.34022, 45.43514],
              [12.34028, 45.43515],
              [12.34035, 45.435],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 32.21,
        UN_VOL_POR: "01",
        UN_VOL_QE: 33.24,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.4,
        UN_VOL_QG: 32.61,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34049, 45.43362],
              [12.34049, 45.4336],
              [12.34043, 45.43359],
              [12.34043, 45.4336],
              [12.34042, 45.43363],
              [12.34048, 45.43364],
              [12.34049, 45.43362],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 20.04,
        UN_VOL_POR: "03",
        UN_VOL_QE: 31.37,
        UN_VOL_EX: "0",
        UN_VOL_QB: 6.25,
        UN_VOL_QG: 26.29,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34088, 45.43375],
              [12.3409, 45.4337],
              [12.34078, 45.43368],
              [12.34049, 45.43362],
              [12.34048, 45.43364],
              [12.34042, 45.43363],
              [12.34043, 45.4336],
              [12.34007, 45.43353],
              [12.34005, 45.43358],
              [12.34088, 45.43375],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.18,
        UN_VOL_POR: "01",
        UN_VOL_QE: 13.27,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 12.91,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33986, 45.43488],
              [12.33967, 45.43484],
              [12.33966, 45.43486],
              [12.33967, 45.43486],
              [12.33985, 45.4349],
              [12.33986, 45.43488],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.77,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.41,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.78,
        UN_VOL_QG: 16.55,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33993, 45.43489],
              [12.33988, 45.43488],
              [12.33987, 45.43492],
              [12.33991, 45.43493],
              [12.33993, 45.43489],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 21.8,
        UN_VOL_POR: "01",
        UN_VOL_QE: 25.32,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 22.53,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33997, 45.43514],
              [12.33998, 45.43513],
              [12.33996, 45.43513],
              [12.33998, 45.4351],
              [12.33997, 45.4351],
              [12.33985, 45.43507],
              [12.33986, 45.43504],
              [12.3399, 45.43505],
              [12.33995, 45.43494],
              [12.33991, 45.43493],
              [12.33987, 45.43492],
              [12.33986, 45.43492],
              [12.33986, 45.43491],
              [12.33983, 45.4349],
              [12.33973, 45.43508],
              [12.33974, 45.43508],
              [12.33982, 45.43511],
              [12.33982, 45.4351],
              [12.33997, 45.43514],
              [12.33997, 45.43514],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 20.04,
        UN_VOL_POR: "03",
        UN_VOL_QE: 31.37,
        UN_VOL_EX: "0",
        UN_VOL_QB: 6.25,
        UN_VOL_QG: 26.29,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33983, 45.43414],
              [12.34005, 45.43358],
              [12.34007, 45.43353],
              [12.33999, 45.43351],
              [12.33997, 45.43357],
              [12.33987, 45.43383],
              [12.33986, 45.43383],
              [12.33984, 45.43389],
              [12.33985, 45.43389],
              [12.33975, 45.43413],
              [12.33983, 45.43414],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 20.04,
        UN_VOL_POR: "03",
        UN_VOL_QE: 31.37,
        UN_VOL_EX: "0",
        UN_VOL_QB: 6.25,
        UN_VOL_QG: 26.29,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33981, 45.43419],
              [12.33983, 45.43414],
              [12.33975, 45.43413],
              [12.33973, 45.43417],
              [12.33981, 45.43419],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 20.04,
        UN_VOL_POR: "03",
        UN_VOL_QE: 31.37,
        UN_VOL_EX: "0",
        UN_VOL_QB: 6.25,
        UN_VOL_QG: 26.29,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33973, 45.43417],
              [12.33973, 45.4342],
              [12.3398, 45.43421],
              [12.33981, 45.43419],
              [12.33973, 45.43417],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 18.96,
        UN_VOL_POR: "01",
        UN_VOL_QE: 20.33,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.74,
        UN_VOL_QG: 19.7,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33986, 45.43422],
              [12.33981, 45.43421],
              [12.33979, 45.43426],
              [12.33978, 45.43427],
              [12.33984, 45.43428],
              [12.33986, 45.43422],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.54,
        UN_VOL_POR: "01",
        UN_VOL_QE: 31.37,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.75,
        UN_VOL_QG: 26.29,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33997, 45.43422],
              [12.33998, 45.43417],
              [12.33983, 45.43414],
              [12.33981, 45.43419],
              [12.33997, 45.43422],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.54,
        UN_VOL_POR: "01",
        UN_VOL_QE: 31.37,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.75,
        UN_VOL_QG: 26.29,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3398, 45.43421],
              [12.33981, 45.43421],
              [12.33986, 45.43422],
              [12.33995, 45.43424],
              [12.33996, 45.43424],
              [12.33997, 45.43422],
              [12.33981, 45.43419],
              [12.3398, 45.43421],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 16.63,
        UN_VOL_POR: "01",
        UN_VOL_QE: 18.5,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.76,
        UN_VOL_QG: 17.39,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33991, 45.4343],
              [12.33984, 45.43428],
              [12.33982, 45.43433],
              [12.3399, 45.43434],
              [12.33991, 45.4343],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 21.5,
        UN_VOL_POR: "01",
        UN_VOL_QE: 24.02,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.74,
        UN_VOL_QG: 22.24,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33979, 45.43442],
              [12.33962, 45.43438],
              [12.33962, 45.43438],
              [12.33959, 45.43444],
              [12.33978, 45.43448],
              [12.3398, 45.43442],
              [12.33979, 45.43442],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 19.11,
        UN_VOL_POR: "01",
        UN_VOL_QE: 24.56,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 19.84,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33975, 45.43465],
              [12.33982, 45.43449],
              [12.33978, 45.43448],
              [12.33959, 45.43444],
              [12.33951, 45.43442],
              [12.33942, 45.43464],
              [12.33967, 45.43469],
              [12.33967, 45.43468],
              [12.33975, 45.43465],
            ],
            [
              [12.33957, 45.4345],
              [12.33958, 45.4345],
              [12.33959, 45.43449],
              [12.3396, 45.43448],
              [12.33961, 45.43448],
              [12.33962, 45.43447],
              [12.33963, 45.43447],
              [12.33965, 45.43447],
              [12.33966, 45.43447],
              [12.33968, 45.43447],
              [12.33969, 45.43447],
              [12.3397, 45.43447],
              [12.33971, 45.43448],
              [12.33973, 45.43449],
              [12.33974, 45.43449],
              [12.33974, 45.4345],
              [12.33975, 45.43451],
              [12.33975, 45.43452],
              [12.33976, 45.43453],
              [12.33976, 45.43454],
              [12.33976, 45.43455],
              [12.33975, 45.43456],
              [12.33975, 45.43457],
              [12.33974, 45.43457],
              [12.33973, 45.43458],
              [12.33972, 45.43459],
              [12.33971, 45.4346],
              [12.3397, 45.4346],
              [12.33968, 45.43461],
              [12.33967, 45.43461],
              [12.33966, 45.43461],
              [12.33964, 45.43461],
              [12.33963, 45.43461],
              [12.33961, 45.4346],
              [12.3396, 45.4346],
              [12.33959, 45.43459],
              [12.33958, 45.43459],
              [12.33957, 45.43458],
              [12.33956, 45.43457],
              [12.33956, 45.43456],
              [12.33956, 45.43455],
              [12.33955, 45.43454],
              [12.33956, 45.43453],
              [12.33956, 45.43452],
              [12.33956, 45.43451],
              [12.33957, 45.4345],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.17,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.11,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 15.9,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33964, 45.43476],
              [12.33947, 45.43472],
              [12.33945, 45.43475],
              [12.33945, 45.43476],
              [12.3396, 45.43479],
              [12.33959, 45.4348],
              [12.33959, 45.4348],
              [12.33961, 45.4348],
              [12.33961, 45.4348],
              [12.33961, 45.4348],
              [12.33963, 45.43476],
              [12.33964, 45.43476],
              [12.33964, 45.43476],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.14,
        UN_VOL_POR: "01",
        UN_VOL_QE: 43.05,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.78,
        UN_VOL_QG: 25.92,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33988, 45.43451],
              [12.33986, 45.43452],
              [12.33985, 45.43452],
              [12.33984, 45.43452],
              [12.33982, 45.43453],
              [12.33982, 45.43453],
              [12.33981, 45.43454],
              [12.3398, 45.43455],
              [12.3398, 45.43456],
              [12.33979, 45.43456],
              [12.33979, 45.43457],
              [12.33979, 45.43458],
              [12.33979, 45.43459],
              [12.33979, 45.4346],
              [12.3398, 45.43461],
              [12.33981, 45.43462],
              [12.33981, 45.43463],
              [12.33982, 45.43463],
              [12.33983, 45.43464],
              [12.33984, 45.43464],
              [12.33985, 45.43465],
              [12.33987, 45.43465],
              [12.33988, 45.43465],
              [12.3399, 45.43465],
              [12.33991, 45.43465],
              [12.33992, 45.43465],
              [12.33994, 45.43464],
              [12.33995, 45.43464],
              [12.33996, 45.43463],
              [12.33996, 45.43462],
              [12.33997, 45.43462],
              [12.33998, 45.43461],
              [12.33998, 45.4346],
              [12.33998, 45.43459],
              [12.33998, 45.43458],
              [12.33998, 45.43457],
              [12.33998, 45.43456],
              [12.33997, 45.43455],
              [12.33996, 45.43454],
              [12.33995, 45.43453],
              [12.33994, 45.43453],
              [12.33993, 45.43452],
              [12.33992, 45.43452],
              [12.3399, 45.43451],
              [12.33989, 45.43451],
              [12.33988, 45.43451],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 20.67,
        UN_VOL_POR: "01",
        UN_VOL_QE: 23.7,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.78,
        UN_VOL_QG: 21.45,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33996, 45.43467],
              [12.34002, 45.43453],
              [12.33982, 45.43449],
              [12.33975, 45.43465],
              [12.33996, 45.43469],
              [12.33996, 45.43467],
            ],
            [
              [12.33982, 45.43453],
              [12.33984, 45.43452],
              [12.33985, 45.43452],
              [12.33986, 45.43452],
              [12.33988, 45.43451],
              [12.33989, 45.43451],
              [12.3399, 45.43451],
              [12.33992, 45.43452],
              [12.33993, 45.43452],
              [12.33994, 45.43453],
              [12.33995, 45.43453],
              [12.33996, 45.43454],
              [12.33997, 45.43455],
              [12.33998, 45.43456],
              [12.33998, 45.43457],
              [12.33998, 45.43458],
              [12.33998, 45.43459],
              [12.33998, 45.4346],
              [12.33998, 45.43461],
              [12.33997, 45.43462],
              [12.33996, 45.43462],
              [12.33996, 45.43463],
              [12.33995, 45.43464],
              [12.33994, 45.43464],
              [12.33992, 45.43465],
              [12.33991, 45.43465],
              [12.3399, 45.43465],
              [12.33988, 45.43465],
              [12.33987, 45.43465],
              [12.33985, 45.43465],
              [12.33984, 45.43464],
              [12.33983, 45.43464],
              [12.33982, 45.43463],
              [12.33981, 45.43463],
              [12.33981, 45.43462],
              [12.3398, 45.43461],
              [12.33979, 45.4346],
              [12.33979, 45.43459],
              [12.33979, 45.43458],
              [12.33979, 45.43457],
              [12.33979, 45.43456],
              [12.3398, 45.43456],
              [12.3398, 45.43455],
              [12.33981, 45.43454],
              [12.33982, 45.43453],
              [12.33982, 45.43453],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 18.47,
        UN_VOL_POR: "01",
        UN_VOL_QE: 23.26,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.74,
        UN_VOL_QG: 19.21,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33993, 45.43489],
              [12.33996, 45.43482],
              [12.33997, 45.43479],
              [12.33999, 45.43475],
              [12.33999, 45.43474],
              [12.33994, 45.43473],
              [12.33996, 45.43469],
              [12.33975, 45.43465],
              [12.33967, 45.43468],
              [12.33967, 45.43469],
              [12.33964, 45.43476],
              [12.33964, 45.43476],
              [12.33963, 45.43476],
              [12.33961, 45.4348],
              [12.3396, 45.43483],
              [12.33963, 45.43484],
              [12.33963, 45.43483],
              [12.33967, 45.43484],
              [12.33986, 45.43488],
              [12.33988, 45.43488],
              [12.33993, 45.43489],
              [12.33993, 45.43489],
            ],
            [
              [12.33973, 45.43477],
              [12.33973, 45.43476],
              [12.33973, 45.43475],
              [12.33973, 45.43474],
              [12.33974, 45.43473],
              [12.33974, 45.43472],
              [12.33975, 45.43472],
              [12.33976, 45.43471],
              [12.33976, 45.43471],
              [12.33977, 45.4347],
              [12.33979, 45.4347],
              [12.3398, 45.43469],
              [12.33981, 45.43469],
              [12.33983, 45.43469],
              [12.33984, 45.4347],
              [12.33985, 45.4347],
              [12.33986, 45.4347],
              [12.33987, 45.43471],
              [12.33988, 45.43472],
              [12.33989, 45.43472],
              [12.3399, 45.43473],
              [12.3399, 45.43474],
              [12.3399, 45.43475],
              [12.3399, 45.43476],
              [12.3399, 45.43477],
              [12.3399, 45.43478],
              [12.33989, 45.43479],
              [12.33988, 45.43479],
              [12.33988, 45.43479],
              [12.33987, 45.4348],
              [12.33986, 45.43481],
              [12.33985, 45.43481],
              [12.33983, 45.43481],
              [12.33982, 45.43481],
              [12.33981, 45.43481],
              [12.33979, 45.43481],
              [12.33978, 45.43481],
              [12.33977, 45.43481],
              [12.33976, 45.4348],
              [12.33975, 45.43479],
              [12.33974, 45.43479],
              [12.33974, 45.43478],
              [12.33973, 45.43477],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 23.97,
        UN_VOL_POR: "01",
        UN_VOL_QE: 37.2,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.75,
        UN_VOL_QG: 24.72,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33976, 45.43471],
              [12.33976, 45.43471],
              [12.33975, 45.43472],
              [12.33974, 45.43472],
              [12.33974, 45.43473],
              [12.33973, 45.43474],
              [12.33973, 45.43475],
              [12.33973, 45.43476],
              [12.33973, 45.43477],
              [12.33974, 45.43478],
              [12.33974, 45.43479],
              [12.33975, 45.43479],
              [12.33976, 45.4348],
              [12.33977, 45.43481],
              [12.33978, 45.43481],
              [12.33979, 45.43481],
              [12.33981, 45.43481],
              [12.33982, 45.43481],
              [12.33983, 45.43481],
              [12.33985, 45.43481],
              [12.33986, 45.43481],
              [12.33987, 45.4348],
              [12.33988, 45.43479],
              [12.33988, 45.43479],
              [12.33989, 45.43479],
              [12.3399, 45.43478],
              [12.3399, 45.43477],
              [12.3399, 45.43476],
              [12.3399, 45.43475],
              [12.3399, 45.43474],
              [12.3399, 45.43473],
              [12.33989, 45.43472],
              [12.33988, 45.43472],
              [12.33987, 45.43471],
              [12.33986, 45.4347],
              [12.33985, 45.4347],
              [12.33984, 45.4347],
              [12.33983, 45.43469],
              [12.33981, 45.43469],
              [12.3398, 45.43469],
              [12.33979, 45.4347],
              [12.33977, 45.4347],
              [12.33976, 45.43471],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.61,
        UN_VOL_POR: "01",
        UN_VOL_QE: 14.73,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.91,
        UN_VOL_QG: 13.52,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3401, 45.43427],
              [12.3401, 45.43426],
              [12.34013, 45.43427],
              [12.34014, 45.43425],
              [12.34014, 45.43424],
              [12.34011, 45.43424],
              [12.34011, 45.43424],
              [12.33997, 45.43422],
              [12.33996, 45.43424],
              [12.33995, 45.43424],
              [12.33995, 45.43424],
              [12.33999, 45.43425],
              [12.33999, 45.43426],
              [12.34005, 45.43427],
              [12.34006, 45.43426],
              [12.3401, 45.43427],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.54,
        UN_VOL_POR: "01",
        UN_VOL_QE: 31.37,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.75,
        UN_VOL_QG: 26.29,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33998, 45.43417],
              [12.34012, 45.4338],
              [12.34055, 45.43389],
              [12.34038, 45.43431],
              [12.34035, 45.4344],
              [12.34032, 45.43447],
              [12.3403, 45.43453],
              [12.34029, 45.43454],
              [12.3403, 45.43454],
              [12.34046, 45.43457],
              [12.34049, 45.43457],
              [12.34061, 45.43459],
              [12.34076, 45.43415],
              [12.34085, 45.43389],
              [12.34084, 45.43389],
              [12.34088, 45.43375],
              [12.34005, 45.43358],
              [12.33983, 45.43414],
              [12.33998, 45.43417],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 19.05,
        UN_VOL_POR: "01",
        UN_VOL_QE: 21.66,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.7,
        UN_VOL_QG: 19.75,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33999, 45.43483],
              [12.33996, 45.43482],
              [12.33993, 45.43489],
              [12.33996, 45.43489],
              [12.33999, 45.43483],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 19.52,
        UN_VOL_POR: "01",
        UN_VOL_QE: 22.49,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.85,
        UN_VOL_QG: 20.37,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33996, 45.43502],
              [12.34001, 45.43491],
              [12.34001, 45.43491],
              [12.33996, 45.43489],
              [12.33993, 45.43489],
              [12.33993, 45.43489],
              [12.33991, 45.43493],
              [12.33995, 45.43494],
              [12.3399, 45.43505],
              [12.33994, 45.43506],
              [12.33996, 45.43502],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.36,
        UN_VOL_POR: "01",
        UN_VOL_QE: 18.0,
        UN_VOL_EX: "0",
        UN_VOL_QB: 1.01,
        UN_VOL_QG: 16.37,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34012, 45.43506],
              [12.34012, 45.43506],
              [12.33996, 45.43502],
              [12.33994, 45.43506],
              [12.33999, 45.43507],
              [12.34003, 45.43508],
              [12.3401, 45.4351],
              [12.34012, 45.43506],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 24.88,
        UN_VOL_POR: "01",
        UN_VOL_QE: 26.27,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.94,
        UN_VOL_QG: 25.82,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34003, 45.43508],
              [12.33999, 45.43507],
              [12.33998, 45.43509],
              [12.34002, 45.4351],
              [12.34003, 45.43508],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.36,
        UN_VOL_POR: "01",
        UN_VOL_QE: 16.11,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.75,
        UN_VOL_QG: 16.11,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33993, 45.4343],
              [12.33995, 45.43424],
              [12.33995, 45.43424],
              [12.33986, 45.43422],
              [12.33984, 45.43428],
              [12.33991, 45.4343],
              [12.33992, 45.43429],
              [12.33993, 45.4343],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 24.15,
        UN_VOL_POR: "01",
        UN_VOL_QE: 25.21,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.88,
        UN_VOL_QG: 25.03,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34002, 45.4351],
              [12.33998, 45.43509],
              [12.33997, 45.4351],
              [12.33998, 45.4351],
              [12.34001, 45.43511],
              [12.34002, 45.4351],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 22.44,
        UN_VOL_POR: "01",
        UN_VOL_QE: 24.4,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.84,
        UN_VOL_QG: 23.28,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34001, 45.43511],
              [12.33998, 45.4351],
              [12.33996, 45.43513],
              [12.33998, 45.43513],
              [12.34, 45.43514],
              [12.34001, 45.43511],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.42,
        UN_VOL_POR: "01",
        UN_VOL_QE: 19.73,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.96,
        UN_VOL_QG: 18.38,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34023, 45.43511],
              [12.34021, 45.43511],
              [12.34022, 45.43509],
              [12.34012, 45.43506],
              [12.3401, 45.4351],
              [12.34021, 45.43513],
              [12.3402, 45.43513],
              [12.34022, 45.43514],
              [12.34023, 45.43511],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 19.58,
        UN_VOL_POR: "01",
        UN_VOL_QE: 22.55,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.65,
        UN_VOL_QG: 20.23,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34046, 45.43495],
              [12.34047, 45.43491],
              [12.34046, 45.43491],
              [12.34046, 45.43491],
              [12.34029, 45.43487],
              [12.34005, 45.4348],
              [12.34001, 45.43479],
              [12.34001, 45.43479],
              [12.33999, 45.43483],
              [12.33996, 45.43489],
              [12.34001, 45.43491],
              [12.34001, 45.43491],
              [12.34029, 45.43498],
              [12.34035, 45.435],
              [12.3404, 45.43501],
              [12.3404, 45.43501],
              [12.34043, 45.43502],
              [12.34046, 45.43495],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 28.74,
        UN_VOL_POR: "01",
        UN_VOL_QE: 30.29,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 29.47,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3393, 45.43468],
              [12.33929, 45.43468],
              [12.33931, 45.43462],
              [12.33932, 45.43461],
              [12.33936, 45.43452],
              [12.33933, 45.43451],
              [12.3393, 45.43451],
              [12.33922, 45.43469],
              [12.33929, 45.43471],
              [12.3393, 45.43468],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 28.1,
        UN_VOL_POR: "01",
        UN_VOL_QE: 29.4,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 28.83,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33932, 45.43461],
              [12.33931, 45.43462],
              [12.33933, 45.43462],
              [12.33933, 45.43461],
              [12.33932, 45.43461],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.27,
        UN_VOL_POR: "01",
        UN_VOL_QE: 13.09,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 13.0,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33947, 45.43472],
              [12.3393, 45.43468],
              [12.33929, 45.43471],
              [12.33922, 45.43469],
              [12.33921, 45.4347],
              [12.33945, 45.43475],
              [12.33947, 45.43472],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 11.96,
        UN_VOL_POR: "01",
        UN_VOL_QE: 12.86,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 12.69,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33965, 45.43431],
              [12.33965, 45.43431],
              [12.33966, 45.4343],
              [12.33946, 45.43426],
              [12.33947, 45.43424],
              [12.33941, 45.43422],
              [12.33929, 45.43451],
              [12.3393, 45.43451],
              [12.33933, 45.43451],
              [12.33942, 45.43427],
              [12.33965, 45.43431],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.92,
        UN_VOL_POR: "01",
        UN_VOL_QE: 24.08,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 18.65,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33967, 45.43469],
              [12.33942, 45.43464],
              [12.33951, 45.43442],
              [12.33959, 45.43444],
              [12.33962, 45.43438],
              [12.33962, 45.43438],
              [12.33965, 45.43431],
              [12.33942, 45.43427],
              [12.33933, 45.43451],
              [12.33936, 45.43452],
              [12.33932, 45.43461],
              [12.33933, 45.43461],
              [12.33933, 45.43462],
              [12.33931, 45.43462],
              [12.33929, 45.43468],
              [12.3393, 45.43468],
              [12.33947, 45.43472],
              [12.33964, 45.43476],
              [12.33967, 45.43469],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 25.42,
        UN_VOL_POR: "01",
        UN_VOL_QE: 39.8,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 26.15,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33965, 45.43447],
              [12.33963, 45.43447],
              [12.33962, 45.43447],
              [12.33961, 45.43448],
              [12.3396, 45.43448],
              [12.33959, 45.43449],
              [12.33958, 45.4345],
              [12.33957, 45.4345],
              [12.33956, 45.43451],
              [12.33956, 45.43452],
              [12.33956, 45.43453],
              [12.33955, 45.43454],
              [12.33956, 45.43455],
              [12.33956, 45.43456],
              [12.33956, 45.43457],
              [12.33957, 45.43458],
              [12.33958, 45.43459],
              [12.33959, 45.43459],
              [12.3396, 45.4346],
              [12.33961, 45.4346],
              [12.33963, 45.43461],
              [12.33964, 45.43461],
              [12.33966, 45.43461],
              [12.33967, 45.43461],
              [12.33968, 45.43461],
              [12.3397, 45.4346],
              [12.33971, 45.4346],
              [12.33972, 45.43459],
              [12.33973, 45.43458],
              [12.33974, 45.43457],
              [12.33975, 45.43457],
              [12.33975, 45.43456],
              [12.33976, 45.43455],
              [12.33976, 45.43454],
              [12.33976, 45.43453],
              [12.33975, 45.43452],
              [12.33975, 45.43451],
              [12.33974, 45.4345],
              [12.33974, 45.43449],
              [12.33973, 45.43449],
              [12.33971, 45.43448],
              [12.3397, 45.43447],
              [12.33969, 45.43447],
              [12.33968, 45.43447],
              [12.33966, 45.43447],
              [12.33965, 45.43447],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 11.07,
        UN_VOL_POR: "01",
        UN_VOL_QE: 13.98,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.75,
        UN_VOL_QG: 11.82,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33982, 45.43433],
              [12.33984, 45.43428],
              [12.33978, 45.43427],
              [12.33979, 45.43426],
              [12.3397, 45.43425],
              [12.3397, 45.43427],
              [12.33968, 45.43431],
              [12.33965, 45.43431],
              [12.33965, 45.43431],
              [12.33962, 45.43438],
              [12.33979, 45.43442],
              [12.33982, 45.43433],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 9.47,
        UN_VOL_POR: "01",
        UN_VOL_QE: 14.04,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.48,
        UN_VOL_QG: 9.95,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34041, 45.43471],
              [12.34028, 45.43468],
              [12.34026, 45.43469],
              [12.34025, 45.43469],
              [12.34022, 45.43478],
              [12.34027, 45.43479],
              [12.34032, 45.4348],
              [12.34033, 45.43478],
              [12.34038, 45.43479],
              [12.34041, 45.43471],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 24.73,
        UN_VOL_POR: "01",
        UN_VOL_QE: 28.04,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.37,
        UN_VOL_QG: 25.1,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34056, 45.43475],
              [12.34055, 45.43475],
              [12.34043, 45.43472],
              [12.34043, 45.43471],
              [12.34041, 45.43471],
              [12.34038, 45.43479],
              [12.34033, 45.43478],
              [12.34032, 45.4348],
              [12.3403, 45.43486],
              [12.3405, 45.4349],
              [12.34051, 45.4349],
              [12.34056, 45.43475],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 26.03,
        UN_VOL_POR: "01",
        UN_VOL_QE: 29.91,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.45,
        UN_VOL_QG: 26.48,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34061, 45.43459],
              [12.34049, 45.43457],
              [12.34047, 45.43464],
              [12.34046, 45.43463],
              [12.34046, 45.43464],
              [12.34043, 45.43471],
              [12.34043, 45.43472],
              [12.34055, 45.43475],
              [12.34061, 45.43459],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 18.76,
        UN_VOL_POR: "01",
        UN_VOL_QE: 19.49,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 19.49,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34022, 45.43514],
              [12.34022, 45.43514],
              [12.3402, 45.43513],
              [12.34019, 45.43515],
              [12.34021, 45.43516],
              [12.34022, 45.43514],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 16.35,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.36,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.85,
        UN_VOL_QG: 17.2,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34024, 45.43509],
              [12.34022, 45.43509],
              [12.34021, 45.43511],
              [12.34023, 45.43511],
              [12.34024, 45.43509],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 17.14,
        UN_VOL_POR: "01",
        UN_VOL_QE: 20.01,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.73,
        UN_VOL_QG: 17.87,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34043, 45.43502],
              [12.3404, 45.43501],
              [12.3404, 45.43501],
              [12.34035, 45.435],
              [12.34028, 45.43515],
              [12.34022, 45.43514],
              [12.34021, 45.43516],
              [12.34019, 45.43515],
              [12.3402, 45.43513],
              [12.34021, 45.43513],
              [12.3401, 45.4351],
              [12.34003, 45.43508],
              [12.34002, 45.4351],
              [12.34001, 45.43511],
              [12.34, 45.43514],
              [12.33998, 45.43513],
              [12.33997, 45.43514],
              [12.34035, 45.43524],
              [12.34043, 45.43502],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 8.08,
        UN_VOL_POR: "01",
        UN_VOL_QE: 10.79,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.83,
        UN_VOL_QG: 8.91,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34008, 45.43432],
              [12.3401, 45.43427],
              [12.34006, 45.43426],
              [12.34005, 45.43427],
              [12.33999, 45.43426],
              [12.33999, 45.43425],
              [12.33995, 45.43424],
              [12.33993, 45.4343],
              [12.33994, 45.4343],
              [12.33994, 45.4343],
              [12.34007, 45.43433],
              [12.34008, 45.43432],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 16.85,
        UN_VOL_POR: "01",
        UN_VOL_QE: 19.06,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.9,
        UN_VOL_QG: 17.75,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34014, 45.43425],
              [12.34013, 45.43427],
              [12.3401, 45.43426],
              [12.3401, 45.43427],
              [12.34008, 45.43432],
              [12.34013, 45.43434],
              [12.34012, 45.43434],
              [12.34017, 45.43435],
              [12.34017, 45.43434],
              [12.34019, 45.4343],
              [12.3402, 45.43428],
              [12.34018, 45.43427],
              [12.34019, 45.43426],
              [12.34014, 45.43425],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.16,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.92,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.81,
        UN_VOL_QG: 15.97,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34017, 45.43435],
              [12.34012, 45.43434],
              [12.34009, 45.43434],
              [12.34008, 45.43437],
              [12.34015, 45.43439],
              [12.34017, 45.43435],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 23.89,
        UN_VOL_POR: "01",
        UN_VOL_QE: 37.08,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.79,
        UN_VOL_QG: 24.68,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33996, 45.43435],
              [12.33994, 45.43435],
              [12.33993, 45.43435],
              [12.33992, 45.43436],
              [12.33991, 45.43436],
              [12.3399, 45.43437],
              [12.3399, 45.43437],
              [12.33989, 45.43438],
              [12.33988, 45.43439],
              [12.33988, 45.43439],
              [12.33988, 45.4344],
              [12.33988, 45.43441],
              [12.33988, 45.43442],
              [12.33988, 45.43443],
              [12.33989, 45.43444],
              [12.3399, 45.43445],
              [12.33991, 45.43445],
              [12.33992, 45.43446],
              [12.33992, 45.43446],
              [12.33994, 45.43447],
              [12.33995, 45.43447],
              [12.33996, 45.43447],
              [12.33998, 45.43447],
              [12.33999, 45.43447],
              [12.34, 45.43446],
              [12.34001, 45.43446],
              [12.34002, 45.43445],
              [12.34003, 45.43445],
              [12.34004, 45.43444],
              [12.34005, 45.43443],
              [12.34005, 45.43442],
              [12.34005, 45.43441],
              [12.34005, 45.4344],
              [12.34005, 45.43439],
              [12.34004, 45.43438],
              [12.34004, 45.43437],
              [12.34003, 45.43437],
              [12.34002, 45.43436],
              [12.34001, 45.43436],
              [12.34, 45.43435],
              [12.33998, 45.43435],
              [12.33997, 45.43435],
              [12.33996, 45.43435],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 18.28,
        UN_VOL_POR: "01",
        UN_VOL_QE: 23.14,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.76,
        UN_VOL_QG: 19.04,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34011, 45.43448],
              [12.34013, 45.43443],
              [12.34015, 45.43439],
              [12.34008, 45.43437],
              [12.34009, 45.43434],
              [12.34012, 45.43434],
              [12.34013, 45.43434],
              [12.34008, 45.43432],
              [12.34007, 45.43433],
              [12.33994, 45.4343],
              [12.33994, 45.4343],
              [12.33993, 45.4343],
              [12.33992, 45.43429],
              [12.33991, 45.4343],
              [12.3399, 45.43434],
              [12.33982, 45.43433],
              [12.33979, 45.43442],
              [12.3398, 45.43442],
              [12.33978, 45.43448],
              [12.33982, 45.43449],
              [12.34002, 45.43453],
              [12.34011, 45.43448],
            ],
            [
              [12.3399, 45.43437],
              [12.33991, 45.43436],
              [12.33992, 45.43436],
              [12.33993, 45.43435],
              [12.33994, 45.43435],
              [12.33996, 45.43435],
              [12.33997, 45.43435],
              [12.33998, 45.43435],
              [12.34, 45.43435],
              [12.34001, 45.43436],
              [12.34002, 45.43436],
              [12.34003, 45.43437],
              [12.34004, 45.43437],
              [12.34004, 45.43438],
              [12.34005, 45.43439],
              [12.34005, 45.4344],
              [12.34005, 45.43441],
              [12.34005, 45.43442],
              [12.34005, 45.43443],
              [12.34004, 45.43444],
              [12.34003, 45.43445],
              [12.34002, 45.43445],
              [12.34001, 45.43446],
              [12.34, 45.43446],
              [12.33999, 45.43447],
              [12.33998, 45.43447],
              [12.33996, 45.43447],
              [12.33995, 45.43447],
              [12.33994, 45.43447],
              [12.33992, 45.43446],
              [12.33992, 45.43446],
              [12.33991, 45.43445],
              [12.3399, 45.43445],
              [12.33989, 45.43444],
              [12.33988, 45.43443],
              [12.33988, 45.43442],
              [12.33988, 45.43441],
              [12.33988, 45.4344],
              [12.33988, 45.43439],
              [12.33988, 45.43439],
              [12.33989, 45.43438],
              [12.3399, 45.43437],
              [12.3399, 45.43437],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 12.67,
        UN_VOL_POR: "01",
        UN_VOL_QE: 13.68,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.81,
        UN_VOL_QG: 13.48,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34032, 45.43447],
              [12.34013, 45.43443],
              [12.34011, 45.43448],
              [12.34024, 45.43451],
              [12.34024, 45.43451],
              [12.34028, 45.43452],
              [12.3403, 45.43453],
              [12.34032, 45.43447],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 5.41,
        UN_VOL_POR: "01",
        UN_VOL_QE: 6.85,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.75,
        UN_VOL_QG: 6.16,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34038, 45.43431],
              [12.34035, 45.4343],
              [12.34034, 45.43433],
              [12.34032, 45.43437],
              [12.34031, 45.4344],
              [12.34035, 45.4344],
              [12.34038, 45.43431],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.95,
        UN_VOL_POR: "01",
        UN_VOL_QE: 16.8,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.72,
        UN_VOL_QG: 16.67,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34028, 45.43452],
              [12.34024, 45.43451],
              [12.34023, 45.43454],
              [12.34025, 45.43454],
              [12.34025, 45.43456],
              [12.34027, 45.43456],
              [12.34028, 45.43452],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 23.87,
        UN_VOL_POR: "01",
        UN_VOL_QE: 38.03,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.76,
        UN_VOL_QG: 24.63,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.3401, 45.43456],
              [12.34009, 45.43456],
              [12.34007, 45.43457],
              [12.34006, 45.43457],
              [12.34005, 45.43458],
              [12.34004, 45.43458],
              [12.34003, 45.43459],
              [12.34003, 45.4346],
              [12.34002, 45.4346],
              [12.34002, 45.43461],
              [12.34001, 45.43462],
              [12.34001, 45.43463],
              [12.34001, 45.43464],
              [12.34002, 45.43465],
              [12.34002, 45.43466],
              [12.34003, 45.43467],
              [12.34004, 45.43468],
              [12.34004, 45.43468],
              [12.34005, 45.43469],
              [12.34006, 45.43469],
              [12.34008, 45.4347],
              [12.34009, 45.4347],
              [12.34011, 45.4347],
              [12.34012, 45.4347],
              [12.34013, 45.4347],
              [12.34015, 45.4347],
              [12.34016, 45.43469],
              [12.34017, 45.43469],
              [12.34018, 45.43468],
              [12.34019, 45.43467],
              [12.3402, 45.43466],
              [12.3402, 45.43466],
              [12.34021, 45.43465],
              [12.34021, 45.43464],
              [12.34021, 45.43463],
              [12.34021, 45.43462],
              [12.3402, 45.43461],
              [12.3402, 45.4346],
              [12.34019, 45.43459],
              [12.34018, 45.43458],
              [12.34017, 45.43458],
              [12.34016, 45.43457],
              [12.34014, 45.43457],
              [12.34013, 45.43456],
              [12.34011, 45.43456],
              [12.3401, 45.43456],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 18.08,
        UN_VOL_POR: "01",
        UN_VOL_QE: 23.43,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.81,
        UN_VOL_QG: 18.89,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34025, 45.43469],
              [12.34026, 45.43469],
              [12.34028, 45.43468],
              [12.34028, 45.43468],
              [12.34029, 45.43465],
              [12.34029, 45.43463],
              [12.34028, 45.43462],
              [12.34027, 45.43461],
              [12.3403, 45.43454],
              [12.34029, 45.43454],
              [12.3403, 45.43453],
              [12.34028, 45.43452],
              [12.34027, 45.43456],
              [12.34025, 45.43456],
              [12.34025, 45.43454],
              [12.34023, 45.43454],
              [12.34024, 45.43451],
              [12.34024, 45.43451],
              [12.34011, 45.43448],
              [12.34002, 45.43453],
              [12.33996, 45.43467],
              [12.34002, 45.43468],
              [12.33999, 45.43474],
              [12.33999, 45.43475],
              [12.34006, 45.43476],
              [12.34013, 45.43478],
              [12.34016, 45.43471],
              [12.34018, 45.43471],
              [12.3402, 45.43471],
              [12.34022, 45.43471],
              [12.34024, 45.4347],
              [12.34025, 45.43469],
            ],
            [
              [12.34005, 45.43458],
              [12.34006, 45.43457],
              [12.34007, 45.43457],
              [12.34009, 45.43456],
              [12.3401, 45.43456],
              [12.34011, 45.43456],
              [12.34013, 45.43456],
              [12.34014, 45.43457],
              [12.34016, 45.43457],
              [12.34017, 45.43458],
              [12.34018, 45.43458],
              [12.34019, 45.43459],
              [12.3402, 45.4346],
              [12.3402, 45.43461],
              [12.34021, 45.43462],
              [12.34021, 45.43463],
              [12.34021, 45.43464],
              [12.34021, 45.43465],
              [12.3402, 45.43466],
              [12.3402, 45.43466],
              [12.34019, 45.43467],
              [12.34018, 45.43468],
              [12.34017, 45.43469],
              [12.34016, 45.43469],
              [12.34015, 45.4347],
              [12.34013, 45.4347],
              [12.34012, 45.4347],
              [12.34011, 45.4347],
              [12.34009, 45.4347],
              [12.34008, 45.4347],
              [12.34006, 45.43469],
              [12.34005, 45.43469],
              [12.34004, 45.43468],
              [12.34004, 45.43468],
              [12.34003, 45.43467],
              [12.34002, 45.43466],
              [12.34002, 45.43465],
              [12.34001, 45.43464],
              [12.34001, 45.43463],
              [12.34001, 45.43462],
              [12.34002, 45.43461],
              [12.34002, 45.4346],
              [12.34003, 45.4346],
              [12.34003, 45.43459],
              [12.34004, 45.43458],
              [12.34005, 45.43458],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 19.45,
        UN_VOL_POR: "01",
        UN_VOL_QE: 21.78,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.77,
        UN_VOL_QG: 20.22,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.33996, 45.43467],
              [12.33996, 45.43469],
              [12.33994, 45.43473],
              [12.33999, 45.43474],
              [12.34002, 45.43468],
              [12.33996, 45.43467],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 15.46,
        UN_VOL_POR: "01",
        UN_VOL_QE: 17.23,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.71,
        UN_VOL_QG: 16.17,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34001, 45.43479],
              [12.33997, 45.43479],
              [12.33996, 45.43482],
              [12.33999, 45.43483],
              [12.34001, 45.43479],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 6.61,
        UN_VOL_POR: "01",
        UN_VOL_QE: 8.25,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.72,
        UN_VOL_QG: 7.33,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34006, 45.43476],
              [12.33999, 45.43475],
              [12.33997, 45.43479],
              [12.34001, 45.43479],
              [12.34001, 45.43479],
              [12.34005, 45.4348],
              [12.34006, 45.43476],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 8.49,
        UN_VOL_POR: "01",
        UN_VOL_QE: 11.85,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.62,
        UN_VOL_QG: 9.11,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34027, 45.43479],
              [12.34022, 45.43478],
              [12.34025, 45.43469],
              [12.34024, 45.4347],
              [12.34022, 45.43471],
              [12.3402, 45.43471],
              [12.34018, 45.43471],
              [12.34016, 45.43471],
              [12.34013, 45.43478],
              [12.3402, 45.43479],
              [12.3402, 45.43479],
              [12.34026, 45.4348],
              [12.34027, 45.43479],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 26.98,
        UN_VOL_POR: "01",
        UN_VOL_QE: 29.7,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.61,
        UN_VOL_QG: 27.59,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34046, 45.43463],
              [12.34044, 45.43463],
              [12.34046, 45.43457],
              [12.3403, 45.43454],
              [12.34027, 45.43461],
              [12.34046, 45.43464],
              [12.34046, 45.43463],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        UN_VOL_AV: 30.14,
        UN_VOL_POR: "01",
        UN_VOL_QE: 31.06,
        UN_VOL_EX: "0",
        UN_VOL_QB: 0.49,
        UN_VOL_QG: 30.63,
        DATA_CRE: "2013/03/25",
        DATA_MOD: "2015/12/31",
        TIPO_MOD: "01",
        ORIGINE: "01",
        SCRIL: "01",
        CODICE: "020101",
        EDITOR: "geodellavalle",
        CREATOR: null,
        SHAPE_AREA: 0.0,
        SHAPE_LEN: 0.0,
        Name: "San Marco Basilica and the Doge's Palace",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [12.34049, 45.43457],
              [12.34046, 45.43457],
              [12.34044, 45.43463],
              [12.34046, 45.43463],
              [12.34047, 45.43464],
              [12.34049, 45.43457],
            ],
          ],
        ],
      },
    },
  ],
};
